import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation, Link } from "react-router-dom";
import {
  resetSppeState,
  resetDcssState,
  resetHtpState,
  resetNgsState,
  resetGenomicState,
  resetPrimerState,
  resetContractState,
  resetFsaState,
  resetQuoteRequestState,
  resetFreeTrialState,
	resetWpsState,
	resetFreeTrialStateWPS,
	resetFragState,
	resetWpsDqcState,
} from "../../store";
import * as XLSX from "xlsx";
import Alert from "../Alert";
import { url } from "../../configlink";

const AutoSave = ({
  currentOrderForm,
  page,
  handleNextPage,
  handlePrevPage,
  steps,
  setTableData,
  passMessage,
  buttonColor,
  bigDataWarning
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  // const token = localStorage.getItem("token");

  let [showExcelImport, setShowExcelImport] = useState();
  let [showSaveDraft, setShowSaveDraft] = useState();
  let [showAlert, setShowAlert] = useState(false)

  useEffect(() => {
    if (
      location.pathname === "/orders/fsa" ||
      location.pathname === "/orders/genomic" ||
      location.pathname === "/orders/contract" ||
      location.pathname === "/orders/primer" ||
		location.pathname === "/orders/quoterequest" ||
		location.pathname === "/orders/wpsDqc"
    ) {
      setShowExcelImport(false);
    } else {
      setShowExcelImport(true);
    }
  }, []);

  useEffect(() => {
	if (location.pathname === "/orders/quoterequest" || location.pathname === "/orders/freetrial" || location.pathname === "/orders/freetrialwps" || location.pathname === "/orders/wpsDqc") {
      setShowSaveDraft(false);
    } else {
      setShowSaveDraft(true);
    }
  });

  //Buttons
  const handleClick = async (event, type) => {
    if (type === "cancel") {
      if (location.pathname === "/orders/sppe") {
        dispatch(resetSppeState());
      } else if (location.pathname === "/orders/dcss") {
        dispatch(resetDcssState());
      } else if (location.pathname === "/orders/htp") {
        dispatch(resetHtpState());
      } else if (location.pathname === "/orders/ngs") {
        dispatch(resetNgsState());
      } else if (location.pathname === "/orders/genomic") {
        dispatch(resetGenomicState());
      } else if (location.pathname === "/orders/primer") {
        dispatch(resetPrimerState());
      } else if (location.pathname === "/orders/contract") {
        dispatch(resetContractState());
      } else if (location.pathname === "/orders/fsa") {
        dispatch(resetFsaState());
      } else if (location.pathname === "/quoterequest") {
        dispatch(resetQuoteRequestState());
      } else if (location.pathname === "/orders/freetrial") {
        dispatch(resetFreeTrialState());
      } else if (location.pathname === "/orders/wps") {
        dispatch(resetWpsState());
		} else if (location.pathname === "/orders/freetrialwps") {
			dispatch(resetFreeTrialStateWPS());
		} else if (location.pathname === "/orders/fla") {
			dispatch(resetFragState());
		} else if (location.pathname === "/orders/wpsDqc") {
			dispatch(resetWpsDqcState());
		}
      navigate("/dashboard");
    }
    if (type === "import") {
      // alert("import excel");
      handleButtonClick();
    }
    if (type === "saveDraft") {
      getCurrentDetails();
    }
    if (type === "back") {
      handlePrevPage();
    }
    if (type === "next") {
      handleNextPage();
    }
    if (type === "submit") {
      handleNextPage();

      //nothing
    }
  };

  const fileInputRef = useRef(null);

  const keyMapping = {
    "Alternate Protocols": "alt",
    "Banked Previously": "pbp",
    "Conc. (ng/ul)": "dConc",
    "Conc. (pmol/ul)": "pConc",
	"DNA Name": "dName",
	"Sample Name": "dName",
    "Insert Size": "pcrSize",
    "Universal Primers": "library",
    "Primer Library": "library",
    "Primer Name": "pName",
    "DNA Type": "dType",
    "Colony Type": "dType",
    "Format": "dFormat",
    "Sample ID": "sampleID",
    "Sample Type": "sampleType",
    "Target Type": "targetType",
    "Est. Target Size (kb)": "targetSize",
    "Data Analysis": "dataAnalysis",
    "Service Option": "serviceOption",
    "Template Name": "templateName",
    "Sequencing Primer": "sequencingPrimer",
    "Expected Sequencing Size (kb)": "length",
    "Reference DNA Sequence/ Accession Number (If known)": "reference",
    "Additional Comments or Questions": "comments",
	"Sample Conc (ng/ul)": "sampleConc",
  };

  const keysToMappedKeys = (obj, mapping, index) => {
    const newObj = { id: index + 1 }; // Add id property starting from 1
    for (const key in obj) {
      if (Object.hasOwnProperty.call(obj, key)) {
        const newKey = mapping[key] || key; // Use mapped key or fallback to original key
        newObj[newKey] = obj[key];
      }
    }
    return newObj;
  };

  const userid = useSelector((state) => state.user.user.UserId);
  // const userid = 2

  function alertMessage(){
    setShowAlert(true)
    setTimeout(() => {
      setShowAlert(false)
    }, 5000)
  }
  

  const getDate = () => {
    const d = new Date();
    const date = d.getDate().toString().padStart(2, "0");
    const month = (d.getMonth() + 1).toString().padStart(2, "0");
    const year = d.getFullYear();
    const hour = d.getHours().toString().padStart(2, "0");
    const minutes = d.getMinutes().toString().padStart(2, "0");
    const seconds = d.getSeconds().toString().padStart(2, "0");
    return `${year}-${month}-${date} ${hour}:${minutes}:${seconds}`;
  };

  function getCurrentDetails() {
    let reqType;
    let orderId;
    if (location.search) {
      reqType = "PUT";
      orderId = location.search.split("=")[1];
    } else {
      reqType = "POST";
    }

    let orderFormData = currentOrderForm;
    // console.log(orderFormData);

    //sppe
    if (orderFormData.data.orderForm === 25) {
      // console.log("whole", orderFormData);

      let sampleInfo = orderFormData.data;
      let primerDetails = orderFormData.primer;
      let billingInfo = orderFormData.billingInformation;

      const getPage0Data = () => {
        return {
          OrderTypeId: sampleInfo.orderForm,
          OrderDateTime: getDate(),
          ServiceTypeId: sampleInfo.serviceOption ? sampleInfo.serviceOption.value : null,
          iTurnAroundTime: sampleInfo.servicePriority,
          OrderDetails: JSON.stringify(sampleInfo.tableData),
          Consensus: sampleInfo.consensus,
          NumOfRxns: sampleInfo.sampleAmount ? sampleInfo.sampleAmount : null,
        };
      };

      const getPage1Data = () => {
        return {
          TemplateBanking: primerDetails.banking,
          PrimerList: primerDetails.banking === 1 ? JSON.stringify(primerDetails.primerList) : "",
          PrimerSynthesis: primerDetails.synthesis,
          PrimerAmount:
            primerDetails.synthesis === 0
              ? null
              : primerDetails.primerAmount === ""
              ? 0
              : primerDetails.primerAmount,
          primerSynthesisList:
            primerDetails.synthesis === 0 ? "" : JSON.stringify(primerDetails.primerSynthesisList),
          AdditionalComments: primerDetails.comments,
        };
      };

      const getPage2Data = () => {
        return {
          ShippingOption: billingInfo.shippingOption,
          BillingUser: JSON.stringify({
            firstName: billingInfo.firstName,
            lastName: billingInfo.lastName,
            phone: billingInfo.phone,
            email: billingInfo.email,
            company: billingInfo.company,
          }),
          // billing: {
          //   method: billingInfo.billingMethod,
          //   cardType: billingInfo.billingMethod==="Credit Card"?billingInfo.cardType:"",
          //   cardNum: billingInfo.billingMethod==="Credit Card"?billingInfo.ccNumber:"",
          //   expMonth: billingInfo.billingMethod==="Credit Card"?billingInfo.ccMonth:"",
          //   expYear: billingInfo.billingMethod==="Credit Card"?billingInfo.ccYear:"",
          //   cvv: billingInfo.billingMethod==="Credit Card"?billingInfo.cvv:"",
          //   acgtCard: billingInfo.billingMethod==="ACGT Card"?billingInfo.acgtCard:"",
          //   poNumber: billingInfo.billingMethod==="Purchasing Agent"?billingInfo.poNumber:"",
          //   paEmail: billingInfo.billingMethod==="Purchasing Agent"?billingInfo.purchasingAgentEmail:"",
          //   paName: billingInfo.billingMethod==="Purchasing Agent"?billingInfo.purchasingAgentName:""
          // }
        };
      };

      let dataToDb = {};

      if (page === 0) {
        dataToDb = {
          ...getPage0Data(),
        };
      } else if (page === 1) {
        dataToDb = {
          ...getPage0Data(),
          ...getPage1Data(),
        };
      } else if (page === 2 || page === 3) {
        dataToDb = {
          ...getPage0Data(),
          ...getPage1Data(),
          ...getPage2Data(),
        };
      }

      if (
        (page === 2 || page === 3) &&
        billingInfo.shippingOption === "Dropbox" &&
        billingInfo.dropoffDate !== ""
      ) {
        dataToDb = {
          ...dataToDb,
          DropBoxDate: billingInfo.dropoffDate,
          DropBoxId: sampleInfo.dropBoxId,
        };
      }

      if (reqType === "PUT") {
        // console.log("DTD > PUT", dataToDb);
        try {
          fetch(`${url}/api/orderForm/updateUserOrdersDrafts?OrderDraftId=${orderId}`, {
            method: "PUT",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
              } else {
                // alert("Error");
                passMessage("failure")
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      } else if (reqType === "POST") {
        dataToDb = {
          ...dataToDb,
          UserId: userid,
        };
        // console.log("DTD > POST", dataToDb);
        try {
          fetch(`${url}/api/orderForm/createUserOrdersDrafts`, {
            method: "POST",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
                setTimeout(() => {
                  if(window.location.pathname.includes('/orders/sppe')){
                    navigate(`/orders/sppe?draftId=${data.orderDraftId}`);
                  }
                }, 5000)
              } else {
                // alert("Error");
                passMessage("failure")
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      }
    }
    //dcss
    else if (orderFormData.data.orderForm === 34) {
      // console.log("whole", orderFormData);

      let sampleInfo = orderFormData.data;
      let primerDetails = orderFormData.primer;
      let billingInfo = orderFormData.billingInformation;

      const getPage0Data = () => {
        return {
          OrderTypeId: sampleInfo.orderForm,
          OrderDateTime: getDate(),
          NumOfRxns: sampleInfo.sampleAmount ? sampleInfo.sampleAmount : null,
          OrderDetails: JSON.stringify(sampleInfo.tableData),
        };
      };

      const getPage1Data = () => {
        return {
          TemplateBanking: primerDetails.banking,
          PrimerList: primerDetails.banking === 1 ? JSON.stringify(primerDetails.primerList) : "",
          PrimerSynthesis: primerDetails.synthesis,
          PrimerAmount:
            primerDetails.synthesis === 0
              ? null
              : primerDetails.primerAmount === ""
              ? 0
              : primerDetails.primerAmount,
          primerSynthesisList:
            primerDetails.synthesis === 0 ? "" : JSON.stringify(primerDetails.primerSynthesisList),
          AdditionalComments: primerDetails.comments,
        };
      };

      const getPage2Data = () => {
        return {
          ShippingOption: billingInfo.shippingOption,
          BillingUser: JSON.stringify({
            firstName: billingInfo.firstName,
            lastName: billingInfo.lastName,
            phone: billingInfo.phone,
            email: billingInfo.email,
            company: billingInfo.company,
          }),
        };
      };

      let dataToDb = {};

      if (page === 0) {
        dataToDb = {
          ...getPage0Data(),
        };
      } else if (page === 1) {
        dataToDb = {
          ...getPage0Data(),
          ...getPage1Data(),
        };
      } else if (page === 2 || page === 3) {
        dataToDb = {
          ...getPage0Data(),
          ...getPage1Data(),
          ...getPage2Data(),
        };
      }

      if (
        (page === 2 || page === 3) && (billingInfo.shippingOption === "Dropbox") &&
        (billingInfo.dropoffDate !== "")
      ) {
        dataToDb = {
          ...dataToDb,
          DropBoxDate: billingInfo.dropoffDate,
          DropBoxId: sampleInfo.dropBoxId,
        };
      }

      if (reqType === "PUT") {
        // console.log("DTD > PUT", dataToDb);
        try {
          fetch(`${url}/api/orderForm/updateUserOrdersDrafts?OrderDraftId=${orderId}`, {
            method: "PUT",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
              } else {
                // alert("Error");
                passMessage("failure")
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      } else if (reqType === "POST") {
        dataToDb = {
          ...dataToDb,
          UserId: userid,
        };
        // console.log("DTD > POST", dataToDb);
        try {
          fetch(`${url}/api/orderForm/createUserOrdersDrafts`, {
            method: "POST",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
                setTimeout(() => {
                  if(window.location.pathname.includes('/orders/dcss')){
                    navigate(`/orders/dcss?draftId=${data.orderDraftId}`);
                  }
                }, 5000)
              } else {
                // alert("Error");
                passMessage("failure")
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      }
    }
    //fsa
    else if (orderFormData.data.orderForm === 29) {
      // console.log("whole", orderFormData);

      let sampleInfo = orderFormData.data;
      let primerDetails = orderFormData.primer;
      let billingInfo = orderFormData.billingInformation;

      const getPage0Data = () => {
        return {
          OrderTypeId: sampleInfo.orderForm,
          OrderDateTime: getDate(),
          NumOfRxns: sampleInfo.sampleAmount ? sampleInfo.sampleAmount : null,
          OrderDetails: JSON.stringify(sampleInfo.tableData),
        };
      };

      const getPage1Data = () => {
        return {
          PrimerSynthesis: primerDetails.synthesis,
          PrimerAmount:
            primerDetails.synthesis === 0
              ? null
              : primerDetails.primerAmount === ""
              ? 0
              : primerDetails.primerAmount,
          primerSynthesisList:
            primerDetails.synthesis === 0 ? "" : JSON.stringify(primerDetails.primerSynthesisList),
          AdditionalComments: primerDetails.comments,
        };
      };

      const getPage3Data = () => {
        return {
          ShippingOption: billingInfo.shippingOption,
          BillingUser: JSON.stringify({
            firstName: billingInfo.firstName,
            lastName: billingInfo.lastName,
            phone: billingInfo.phone,
            email: billingInfo.email,
            company: billingInfo.company,
          }),
        };
      };

      let dataToDb = {};

      if (page === 0) {
        dataToDb = {
          ...getPage0Data(),
        };
      } else if (page === 1 || page === 2) {
        dataToDb = {
          ...getPage0Data(),
          ...getPage1Data(),
        };
      } else if (page === 3 || page === 4) {
        dataToDb = {
          ...getPage0Data(),
          ...getPage1Data(),
          ...getPage3Data(),
        };
      }

      if (
        (page === 3 || page === 4) &&
        billingInfo.shippingOption === "Dropbox" &&
        billingInfo.dropoffDate !== ""
      ) {
        dataToDb = {
          ...dataToDb,
          DropBoxDate: billingInfo.dropoffDate,
          DropBoxId: sampleInfo.dropBoxId,
        };
      }

      if (reqType === "PUT") {
        // console.log("DTD > PUT", dataToDb);
        try {
          fetch(`${url}/api/orderForm/updateUserOrdersDrafts?OrderDraftId=${orderId}`, {
            method: "PUT",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
              } else {
                passMessage("failure")
                // alert("Error");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      } else if (reqType === "POST") {
        dataToDb = {
          ...dataToDb,
          UserId: userid,
        };
        // console.log("DTD > POST", dataToDb);
        try {
          fetch(`${url}/api/orderForm/createUserOrdersDrafts`, {
            method: "POST",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
                setTimeout(() => {
                  if(window.location.pathname.includes('/orders/fsa')){
                    navigate(`/orders/fsa?draftId=${data.orderDraftId}`);
                  }
                }, 5000)
              } else {
                // alert("Error");
                passMessage("failure")
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      }
    }
    //ngs
    else if (orderFormData.data.orderForm === 37 || orderFormData.data.orderForm === 35) {
      // console.log("whole", orderFormData);

      let sampleInfo = orderFormData.data;
      let billingInfo = orderFormData.billingInformation;

      const getPage0Data = () => {
        return {
          OrderTypeId: sampleInfo.orderForm,
          OrderDateTime: getDate(),
          NumOfRxns: sampleInfo.sampleAmount ? sampleInfo.sampleAmount : null,
          OrderDetails: JSON.stringify(sampleInfo.tableData),
          AdditionalComments: sampleInfo.comments,
        };
      };

      const getPage2Data = () => {
        return {
          ShippingOption: billingInfo.shippingOption,
          BillingUser: JSON.stringify({
            firstName: billingInfo.firstName,
            lastName: billingInfo.lastName,
            phone: billingInfo.phone,
            email: billingInfo.email,
            company: billingInfo.company,
          }),
        };
      };

      let dataToDb = {};

      if (page === 0 || page === 1) {
        dataToDb = {
          ...getPage0Data(),
        };
      } else if (page === 2 || page === 3) {
        dataToDb = {
          ...getPage0Data(),
          ...getPage2Data(),
        };
      }

      if (
        (page === 2 || page === 3) &&
        billingInfo.shippingOption === "Dropbox" &&
        billingInfo.dropoffDate !== ""
      ) {
        dataToDb = {
          ...dataToDb,
          DropBoxDate: billingInfo.dropoffDate,
          DropBoxId: sampleInfo.dropBoxId,
        };
      }

      if (reqType === "PUT") {
        // console.log("DTD > PUT", dataToDb);
        try {
          fetch(`${url}/api/orderForm/updateUserOrdersDrafts?OrderDraftId=${orderId}`, {
            method: "PUT",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
              } else {
                // alert("Error");
                passMessage("failure")
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      } else if (reqType === "POST") {
        dataToDb = {
          ...dataToDb,
          UserId: userid,
        };
        // console.log("DTD > POST", dataToDb);
        try {
          fetch(`${url}/api/orderForm/createUserOrdersDrafts`, {
            method: "POST",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
                setTimeout(() => {
                  if(window.location.pathname.includes('/orders/ngs')){
                    navigate(`/orders/ngs?draftId=${data.orderDraftId}`);
                  }
                }, 5000)
              } else {
                passMessage("failure")
                // alert("Error");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      }
    }
    //genomic
    else if (orderFormData.data.orderForm === 20) {
      // console.log("whole", orderFormData);

      let sampleInfo = orderFormData.data;
      let billingInfo = orderFormData.billingInformation;

      const getPage0Data = () => {
        return {
          OrderTypeId: sampleInfo.orderForm,
          OrderDateTime: getDate(),
          NumOfRxns: sampleInfo.sampleAmount ? sampleInfo.sampleAmount : null,
          OrderDetails: JSON.stringify(sampleInfo.sampleData),
        };
      };

      const getPage2Data = () => {
        return {
          ShippingOption: billingInfo.shippingOption,
          BillingUser: JSON.stringify({
            firstName: billingInfo.firstName,
            lastName: billingInfo.lastName,
            phone: billingInfo.phone,
            email: billingInfo.email,
            company: billingInfo.company,
          }),
        };
      };

      let dataToDb = {};

      if (page === 0 || page === 1) {
        dataToDb = {
          ...getPage0Data(),
        };
      } else if (page === 2 || page === 3) {
        dataToDb = {
          ...getPage0Data(),
          ...getPage2Data(),
        };
      }

      if (
        (page === 2 || page === 3) &&
        billingInfo.shippingOption === "Dropbox" &&
        billingInfo.dropoffDate !== ""
      ) {
        dataToDb = {
          ...dataToDb,
          DropBoxDate: billingInfo.dropoffDate,
          DropBoxId: sampleInfo.dropBoxId,
        };
      }

      if (reqType === "PUT") {
        // console.log("DTD > PUT", dataToDb);
        try {
          fetch(`${url}/api/orderForm/updateUserOrdersDrafts?OrderDraftId=${orderId}`, {
            method: "PUT",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
              } else {
                passMessage("failure")
                // alert("Error");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      } else if (reqType === "POST") {
        dataToDb = {
          ...dataToDb,
          UserId: userid,
        };
        // console.log("DTD > POST", dataToDb);
        try {
          fetch(`${url}/api/orderForm/createUserOrdersDrafts`, {
            method: "POST",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
                setTimeout(() => {
                  if(window.location.pathname.includes('/orders/genomic')){
                    navigate(`/orders/genomic?draftId=${data.orderDraftId}`);
                  }
                }, 5000)
              } else {
                passMessage("failure")
                // alert("Error");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      }
    }
    //primerform
    else if (orderFormData.data.orderForm === 50) {
      // console.log("whole", orderFormData);

      let primerDetails = orderFormData.primer;
      let billingInfo = orderFormData.billingInformation;

      const getPage1Data = () => {
        return {
          OrderTypeId: orderFormData.data.orderForm,
          OrderDateTime: getDate(),
          PrimerSynthesis: primerDetails.synthesis,
          PrimerAmount:
            primerDetails.synthesis === 0
              ? null
              : primerDetails.primerAmount === ""
              ? 0
              : primerDetails.primerAmount,
          primerSynthesisList:
            primerDetails.synthesis === 0 ? "" : JSON.stringify(primerDetails.primerSynthesisList),
          AdditionalComments: primerDetails.comments,
        };
      };

      const getPage2Data = () => {
        return {
          BillingUser: JSON.stringify({
            firstName: billingInfo.firstName,
            lastName: billingInfo.lastName,
            phone: billingInfo.phone,
            email: billingInfo.email,
            company: billingInfo.company,
          }),
        };
      };

      let dataToDb = {};

      if (page === 0) {
        dataToDb = {
          ...getPage1Data(),
        };
      } else if (page === 1 || page === 2) {
        dataToDb = {
          ...getPage1Data(),
          ...getPage2Data(),
        };
      }

      if (reqType === "PUT") {
        // console.log("DTD > PUT", dataToDb);
        try {
          fetch(`${url}/api/orderForm/updateUserOrdersDrafts?OrderDraftId=${orderId}`, {
            method: "PUT",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
              } else {
                passMessage("failure")
                // alert("Error");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      } else if (reqType === "POST") {
        dataToDb = {
          ...dataToDb,
          UserId: userid,
        };
        // console.log("DTD > POST", dataToDb);
        try {
          fetch(`${url}/api/orderForm/createUserOrdersDrafts`, {
            method: "POST",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
                setTimeout(() => {
                  if(window.location.pathname.includes('/orders/primer')){
                    navigate(`/orders/primer?draftId=${data.orderDraftId}`);
                  }
                }, 5000)
              } else {
                passMessage("failure")
                // alert("Error");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      }
    }
    //contract research
    else if (orderFormData.data.orderForm === 31) {
      // console.log("whole", orderFormData);

      let billingInfo = orderFormData.billingInformation;

      const getPage0Data = () => {
        return {
          OrderTypeId: orderFormData.data.orderForm,
          OrderDateTime: getDate(),
          OrderDetails: JSON.stringify(orderFormData.contract),
        };
      };

      const getPage2Data = () => {
        return {
          BillingUser: JSON.stringify({
            firstName: billingInfo.firstName,
            lastName: billingInfo.lastName,
            phone: billingInfo.phone,
            email: billingInfo.email,
            company: billingInfo.company,
          }),
        };
      };

      let dataToDb = {};

      if (page === 0) {
        dataToDb = {
          ...getPage0Data(),
        };
      } else if (page === 1 || page === 2) {
        dataToDb = {
          ...getPage0Data(),
          ...getPage2Data(),
        };
      }

      if (reqType === "PUT") {
        // console.log("DTD > PUT", dataToDb);
        try {
          fetch(`${url}/api/orderForm/updateUserOrdersDrafts?OrderDraftId=${orderId}`, {
            method: "PUT",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
              } else {
                passMessage("failure")
                // alert("Error");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      } else if (reqType === "POST") {
        dataToDb = {
          ...dataToDb,
          UserId: userid,
        };
        // console.log("DTD > POST", dataToDb);
        try {
          fetch(`${url}/api/orderForm/createUserOrdersDrafts`, {
            method: "POST",
            credentials: 'include',
            headers: {
              // Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
            body: JSON.stringify(dataToDb),
          })
            .then((res) => res.json())
            .then((data) => {
              if (data.message === "Success") {
                // alert("Draft saved!");
                // alertMessage()
                passMessage("success")
                setTimeout(() => {
                  if(window.location.pathname.includes('/orders/contract')){
                    navigate(`/orders/contract?draftId=${data.orderDraftId}`);
                  }
                }, 5000)
              } else {
                passMessage("failure")
                // alert("Error");
              }
            })
            .catch((err) => {
              console.error(err);
            });
        } catch (err) {
          console.error(err);
        }
      }
    }
    //htp
    else if (orderFormData.data.orderForm === 28) {
      // console.log("whole", orderFormData);

      let sampleInfo = orderFormData.data;
      let primerDetails = orderFormData.primer;
      let billingInfo = orderFormData.billingInformation;

      if(parseInt(sampleInfo.plateAmount) > 3){
          // alert("3+ Plates")
          bigDataWarning(true)
      }
      else{
        const getPage0Data = () => {
          return {
            OrderTypeId: sampleInfo.orderForm,
            OrderDateTime: getDate(),
            ServiceTypeId: sampleInfo.serviceOption ? sampleInfo.serviceOption.value : null,
            OrderOption: JSON.stringify(sampleInfo.orderOption),
            NumOfRxns: sampleInfo.plateAmount ? sampleInfo.plateAmount : null,
            OrderDetails: JSON.stringify(sampleInfo.tableData),
          };
        };
  
        const getPage1Data = () => {
          return {
            TemplateBanking: primerDetails.banking,
            PrimerList: primerDetails.banking === 1 ? JSON.stringify(primerDetails.primerList) : "",
            PrimerSynthesis: primerDetails.synthesis,
            PrimerAmount:
              primerDetails.synthesis === 0
                ? null
                : primerDetails.primerAmount === ""
                ? 0
                : primerDetails.primerAmount,
            primerSynthesisList:
              primerDetails.synthesis === 0 ? "" : JSON.stringify(primerDetails.primerSynthesisList),
            AdditionalComments: primerDetails.comments,
          };
        };
  
        const getPage2Data = () => {
          return {
            ShippingOption: billingInfo.shippingOption,
            BillingUser: JSON.stringify({
              firstName: billingInfo.firstName,
              lastName: billingInfo.lastName,
              phone: billingInfo.phone,
              email: billingInfo.email,
              company: billingInfo.company,
            }),
          };
        };

        let dataToDb = {};
  
        if (page === 0) {
          dataToDb = {
            ...getPage0Data(),
          };
        } else if (page === 1) {
          dataToDb = {
            ...getPage0Data(),
            ...getPage1Data(),
          };
        } else if (page === 2 || page === 3) {
          dataToDb = {
            ...getPage0Data(),
            ...getPage1Data(),
            ...getPage2Data(),
          };
        }

        if (
          (page === 2 || page === 3) &&
          billingInfo.shippingOption === "Dropbox" &&
          billingInfo.dropoffDate !== ""
        ) {
          dataToDb = {
            ...dataToDb,
            DropBoxDate: billingInfo.dropoffDate,
            DropBoxId: sampleInfo.dropBoxId,
          };
        }

        if (reqType === "PUT") {
          // console.log("DTD > PUT", dataToDb);
          try {
            fetch(`${url}/api/orderForm/updateUserOrdersDrafts?OrderDraftId=${orderId}`, {
              method: "PUT",
              credentials: 'include',
              headers: {
                // Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToDb),
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.message === "Success") {
                  // alert("Draft saved!");
                  // alertMessage()
                  passMessage("success")
                } else {
                  passMessage("failure")
                  // alert("Error");
                }
              })
              .catch((err) => {
                console.error(err);
              });
          } catch (err) {
            console.error(err);
          }
        } else if (reqType === "POST") {
          dataToDb = {
            ...dataToDb,
            UserId: userid,
          };
          // console.log("DTD > POST", dataToDb);
          try {
            fetch(`${url}/api/orderForm/createUserOrdersDrafts`, {
              method: "POST",
              credentials: 'include',
              headers: {
                // Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToDb),
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.message === "Success") {
                  // alert("Draft saved!");
                  // alertMessage()
                  passMessage("success")
                  setTimeout(() => {
                    if(window.location.pathname.includes('/orders/htp')){
                      navigate(`/orders/htp?draftId=${data.orderDraftId}`);
                    }
                  }, 5000)
                } else {
                  // alert("Error");
                  passMessage("failure")
                }
              })
              .catch((err) => {
                console.error(err);
              });
          } catch (err) {
            console.error(err);
          }
        }
      }
	}
	//fla
	else if (orderFormData.data.orderForm === 38) {
		// console.log("whole FLA", orderFormData);

		let sampleInfo = orderFormData.data;
		let primerDetails = orderFormData.primer;
		let billingInfo = orderFormData.billingInformation;

		if(parseInt(sampleInfo.plateAmount) > 3){
			// alert("3+ Plates")
			bigDataWarning(true)
		}
		else{
		const getPage0Data = () => {
          return {
            OrderTypeId: sampleInfo.orderForm,
            OrderDateTime: getDate(),
            // ServiceTypeId: sampleInfo.serviceOption ? sampleInfo.serviceOption.value : null,
            // OrderOption: JSON.stringify(sampleInfo.orderOption),
            NumOfRxns: sampleInfo.plateAmount ? sampleInfo.plateAmount : null,
            OrderDetails: JSON.stringify(sampleInfo.tableData),
            AdditionalComments: primerDetails.comments,
          };
        };
  
        // const getPage1Data = () => {
        //   return {
        //     // TemplateBanking: primerDetails.banking,
        //     // PrimerList: primerDetails.banking === 1 ? JSON.stringify(primerDetails.primerList) : "",
        //     // PrimerSynthesis: primerDetails.synthesis,
        //     // PrimerAmount:
        //     //   primerDetails.synthesis === 0
        //     //     ? null
        //     //     : primerDetails.primerAmount === ""
        //     //     ? 0
        //     //     : primerDetails.primerAmount,
        //     // primerSynthesisList:
        //     //   primerDetails.synthesis === 0 ? "" : JSON.stringify(primerDetails.primerSynthesisList),
        //     // AdditionalComments: primerDetails.comments,
        //   };
        // };
  
        const getPage2Data = () => {
          return {
            ShippingOption: billingInfo.shippingOption,
            BillingUser: JSON.stringify({
              firstName: billingInfo.firstName,
              lastName: billingInfo.lastName,
              phone: billingInfo.phone,
              email: billingInfo.email,
              company: billingInfo.company,
            }),
          };
        };

        let dataToDb = {};
  
        if (page === 0) {
          dataToDb = {
            ...getPage0Data(),
          };
        } else if (page === 1) {
          dataToDb = {
            ...getPage0Data(),
            // ...getPage1Data(),
          };
        } else if (page === 2 || page === 3) {
          dataToDb = {
            ...getPage0Data(),
            // ...getPage1Data(),
            ...getPage2Data(),
          };
        }

        if (
          (page === 2 || page === 3) &&
          billingInfo.shippingOption === "Dropbox" &&
          billingInfo.dropoffDate !== ""
        ) {
          dataToDb = {
            ...dataToDb,
            DropBoxDate: billingInfo.dropoffDate,
            DropBoxId: sampleInfo.dropBoxId,
          };
        }

        if (reqType === "PUT") {
          // console.log("DTD FLA > PUT", dataToDb);
          try {
            fetch(`${url}/api/orderForm/updateUserOrdersDrafts?OrderDraftId=${orderId}`, {
              method: "PUT",
              credentials: 'include',
              headers: {
                // Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToDb),
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.message === "Success") {
                  // alert("Draft saved!");
                  // alertMessage()
                  passMessage("success")
                } else {
                  passMessage("failure")
                  // alert("Error");
                }
              })
              .catch((err) => {
                console.error(err);
              });
          } catch (err) {
            console.error(err);
          }
        } else if (reqType === "POST") {
          dataToDb = {
            ...dataToDb,
            UserId: userid,
          };
          // console.log("DTD FLA > POST", dataToDb);
          try {
            fetch(`${url}/api/orderForm/createUserOrdersDrafts`, {
              method: "POST",
              credentials: 'include',
              headers: {
                // Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
              body: JSON.stringify(dataToDb),
            })
              .then((res) => res.json())
              .then((data) => {
                if (data.message === "Success") {
                  // alert("Draft saved!");
                  // alertMessage()
                  passMessage("success")
                  setTimeout(() => {
					if(window.location.pathname.includes('/orders/fla')){
						navigate(`/orders/fla?draftId=${data.orderDraftId}`);
                    }
                  }, 5000)
                } else {
                  // alert("Error");
                  passMessage("failure")
                }
              })
              .catch((err) => {
                console.error(err);
              });
          } catch (err) {
            console.error(err);
          }
        }
      }
    }
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const allSheets = workbook.SheetNames;
      if (allSheets.length === 1) {
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        let jsonData = XLSX.utils.sheet_to_json(worksheet, { range: 1 });
		// console.log(jsonData.length);

		const columnToExclude = "NOTE";
        jsonData = jsonData.map(row => {
			const { [columnToExclude]: _, ...filteredRow } = row;
			return filteredRow;
        });

        if (jsonData.length > 0) {
          jsonData = jsonData.map((item, index) => keysToMappedKeys(item, keyMapping, index)); // Map keys and add id
          // console.log('singlejson', jsonData);
          setTableData(jsonData);
        } else {
          alert("Please fill the table");
        }
      } else if (allSheets.length > 1) {
        let multipleJson = [];
        for (let i = 0; i < allSheets.length; i++) {
        let sheetName = workbook.SheetNames[i];
        let worksheet = workbook.Sheets[sheetName];
        let jsonData = XLSX.utils.sheet_to_json(worksheet, { range: 1 });

		const columnToExclude = "NOTE";
        jsonData = jsonData.map(row => {
            const { [columnToExclude]: _, ...filteredRow } = row;
            return filteredRow;
        });

          if (jsonData.length > 0) {
            jsonData = jsonData.map((item, index) => keysToMappedKeys(item, keyMapping, index)); // Map keys and add id
            multipleJson.push(jsonData);
          } else {
            alert("Please fill the table");
          }
        }
        // console.log('multiplejson', multipleJson);
        setTableData(multipleJson);
      }

      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const handleButtonClick = () => {
    fileInputRef.current.click();
  };


  switch (steps) {
    case 2:
      return (
        <div className='fixed bottom-0 flex justify-between items-center bg-gray-100 w-full h-[91px] left-0 z-10 px-[72px]'>
          {showAlert && <>
          <div className="fixed bottom-[120px] left-1/2 -translate-x-1/2">
            <Alert type="success">
              <span className="whitespace-nowrap">Form successfully saved to drafts. You can find your saved drafts by going to <Link to="/orderhistory" className="underline">My Orders.</Link></span>
            </Alert>
          </div>
          </>
          }
          <div>
          <button
              className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[116px] h-[43px] mr-6'
              onClick={(event) => handleClick(event, "cancel")}
            >
              cancel
            </button>
            <>
              {showExcelImport && (
                <>
                  <button
                    className='px-4 py-2 rounded-3xl font-bold gap-2 text-white bg-[#60C5C5] uppercase min-w-[210px] h-[43px]'
                    onClick={(event) => handleClick(event, "import")}
                  >
                    import excel file
                  </button>
                  <input
                    type='file'
                    ref={fileInputRef}
                    onChange={handleFileChange}
                    style={{ display: "none" }}
                    accept='.xlsx, .xls'
                  />
                </>
              )}
            </>

            
          </div>
          <div>
    
            {showSaveDraft && (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[153px] h-[43px] mr-6'
                onClick={(event) => handleClick(event, "saveDraft")}
              >
                save draft
              </button>
            )}
            <button
              className={`border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 ${buttonColor? 'bg-[#58595b] pointer-events-none' : 'bg-[#302a7e] '} text-white uppercase min-w-[175px] h-[43px]`}
              onClick={(event) => handleClick(event, "submit")}
            >
              submit order
            </button>
          </div>
        </div>
      );
    case 4:
      return (
        <div className='fixed bottom-0 flex justify-between items-center bg-gray-100 w-full h-[91px] left-0 z-10 px-[72px]'>
          {showAlert && <>
          <div className="fixed bottom-[120px] left-1/2 -translate-x-1/2">
            <Alert type="success">
              <span className="whitespace-nowrap">Form successfully saved to drafts. You can find your saved drafts by going to <Link to="/orderhistory" className="underline">My Orders.</Link></span>
            </Alert>
          </div>
          </>
          }
          <div>
          <button
              className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[116px] h-[43px] mr-6'
              onClick={(event) => handleClick(event, "cancel")}
            >
              cancel
            </button>
            {page > 0 ? (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[94px] h-[43px]  mr-6'
                onClick={(event) => handleClick(event, "back")}
              >
                back
              </button>
            ) : (
              <>
                {showExcelImport && (
                  <>
                    <button
                     className='px-4 py-2 rounded-3xl font-bold gap-2 text-white bg-[#60C5C5] uppercase min-w-[210px] h-[43px]'
                      onClick={(event) => handleClick(event, "import")}
                    >
                      import excel file
                    </button>
                    <input
                      type='file'
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      accept='.xlsx, .xls'
                    />
                  </>
                )}
              </>
            )}

          </div>
          <div>
            
            {showSaveDraft && (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[153px] h-[43px] mr-6'
                onClick={(event) => handleClick(event, "saveDraft")}
              >
                save draft
              </button>
            )}
            {page === 2 ? (
              <button
                className={`border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 ${buttonColor? 'bg-[#58595b] pointer-events-none' : 'bg-[#302a7e] '} text-white uppercase min-w-[175px] h-[43px]`}
                onClick={(event) => handleClick(event, "submit")}
              >
                submit order
              </button>
            ) : (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 bg-[#302a7e] text-white uppercase w-[93px] h-[43px]'
                onClick={(event) => handleClick(event, "next")}
              >
                next
              </button>
            )}
          </div>
        </div>
      );
    case 5:
      return (
        <div className='fixed bottom-0 flex justify-between items-center bg-gray-100 w-full h-[91px] left-0 z-10 px-[72px]'>
          <div>
          {showAlert && <>
          <div className="fixed bottom-[120px] left-1/2 -translate-x-1/2">
            <Alert type="success">
              <span className="whitespace-nowrap">Form successfully saved to drafts. You can find your saved drafts by going to <Link to="/orderhistory" className="underline">My Orders.</Link></span>
            </Alert>
          </div>
          </>
          }

              <button
              className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[116px] h-[43px] mr-6'
              onClick={(event) => handleClick(event, "cancel")}
              >
                cancel
              </button>
            {page > 0 ? (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[94px] h-[43px]  mr-6'
                onClick={(event) => handleClick(event, "back")}
              >
                back
              </button>
            ) : (
              <>
              
                {showExcelImport && (
                  <>
                    <button
                      className='px-4 py-2 rounded-3xl font-bold gap-2 text-white bg-[#60C5C5] uppercase min-w-[210px] h-[43px]'
                      onClick={(event) => handleClick(event, "import")}
                    >
                      import excel file
                    </button>
                    <input
                      type='file'
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      accept='.xlsx, .xls'
                    />
                  </>
                )}
              </>
            )}

            
          </div>
          <div>
            
            {showSaveDraft && (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[153px] h-[43px] mr-6'
                onClick={(event) => handleClick(event, "saveDraft")}
              >
                save draft
              </button>
            )}
            {page === 3 ? (
              <button
                className={`border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 ${buttonColor? 'bg-[#58595b] pointer-events-none' : 'bg-[#302a7e] '} text-white uppercase min-w-[175px] h-[43px]`}
                onClick={(event) => handleClick(event, "submit")}
              >
                submit order
              </button>
            ) : (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 bg-[#302a7e] text-white uppercase w-[93px] h-[43px]'
                onClick={(event) => handleClick(event, "next")}
              >
                next
              </button>
            )}
          </div>
        </div>
      );
    case 6:
      return (
        <div className='fixed bottom-0 flex justify-between items-center bg-gray-100 w-full h-[91px] left-0 z-10 px-[72px]'>
          {showAlert && <>
          <div className="fixed bottom-[120px] left-1/2 -translate-x-1/2">
            <Alert type="success">
              <span className="whitespace-nowrap">Form successfully saved to drafts. You can find your saved drafts by going to <Link to="/orderhistory" className="underline">My Orders.</Link></span>
            </Alert>
          </div>
          </>
          }
          <div>
            <button
              className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[116px] h-[43px] mr-6'
              onClick={(event) => handleClick(event, "cancel")}
            >
              cancel
            </button>
            {page > 0 ? (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase w-[94px] h-[43px]  mr-6'
                onClick={(event) => handleClick(event, "back")}
              >
                back
              </button>
            ) : (
              <>
                {showExcelImport && (
                  <>
                    <button
                      className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[210px] h-[43px]  mr-6'
                      onClick={(event) => handleClick(event, "import")}
                    >
                      import excel file
                    </button>
                    <input
                      type='file'
                      ref={fileInputRef}
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                      accept='.xlsx, .xls'
                    />
                  </>
                )}
              </>
            )}
            
          </div>
          <div>
          {showSaveDraft && (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 text-[var(--color-primary-purple)] bg-white uppercase min-w-[153px] h-[43px] mr-6'
                onClick={(event) => handleClick(event, "saveDraft")}
              >
                save draft
              </button>
            )}  
            {page === 4 ? (
              <button
                className={`border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 ${buttonColor? 'bg-[#58595b] pointer-events-none' : 'bg-[#302a7e] '} text-white uppercase min-w-[175px] h-[43px]`}
                onClick={(event) => handleClick(event, "submit")}
              >
                submit order
              </button>
            ) : (
              <button
                className='border-2 border-[#302a7e] px-4 py-2 rounded-3xl font-bold gap-2 bg-[#302a7e] text-white uppercase w-[93px] h-[43px]'
                onClick={(event) => handleClick(event, "next")}
              >
                next
              </button>
            )}
          </div>
        </div>
      );
    default:
      break;

  }
};

export default AutoSave;